class KudaFinder extends HTMLElement {
  connectedCallback() {
    this.brand = this.querySelector('[data-kuda-brand]');
    this.model = this.querySelector('[data-kuda-model]');
    this.year = this.querySelector('[data-kuda-year]');
    this.button = this.querySelector('[data-kuda-submit]');
    this.results = this.querySelector('[data-kuda-results]');
    this.brand.addEventListener('change', () => this.selectBrand());
    this.model.addEventListener('change', () => this.selectModel());
    this.year.addEventListener('change', () => this.selectYear());
    this.button.addEventListener('click', () => this.showResults());
    this.load();
  }

  async load() {
    try {
      const response = await fetch(this.dataset.indexUrl);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      this.data = await response.json();
      this.fill(this.brand, this.data.brands.map((entry, index) => [index, entry.name]), 'Kies automerk');
      this.preselect();
    } catch (error) {
      this.results.hidden = false;
      this.results.textContent = 'De Kuda-finder kon niet worden geladen. Probeer de pagina opnieuw te laden.';
    }
  }

  fill(select, rows, label) {
    select.innerHTML = `<option value="">${label}</option>` + rows.map(([value, text]) =>
      `<option value="${value}">${this.escape(text)}</option>`).join('');
    select.disabled = rows.length === 0;
  }

  preselect() {
    const current = this.dataset.currentHandle;
    for (let brandIndex = 0; brandIndex < this.data.brands.length; brandIndex++) {
      const brand = this.data.brands[brandIndex];
      const modelIndex = brand.models.findIndex(model => model.handle === current);
      const brandHandle = `kuda-consoles-${this.slug(brand.name)}`;
      if (modelIndex >= 0 || current === brandHandle) {
        this.brand.value = String(brandIndex);
        this.selectBrand();
        if (modelIndex >= 0) {
          this.model.value = String(modelIndex);
          this.selectModel();
        }
        break;
      }
    }
  }

  selectBrand() {
    this.activeBrand = this.data.brands[Number(this.brand.value)];
    const rows = this.activeBrand ? this.activeBrand.models.map((entry, index) => [index, entry.name]) : [];
    this.fill(this.model, rows, 'Kies model');
    this.fill(this.year, [], 'Kies bouwjaar');
    this.resetResults();
  }

  selectModel() {
    this.activeModel = this.activeBrand?.models[Number(this.model.value)];
    const rows = this.activeModel ? Object.keys(this.activeModel.years).map(year => [year, year]) : [];
    this.fill(this.year, rows, 'Kies bouwjaar');
    this.resetResults();
  }

  selectYear() {
    this.matches = this.activeModel?.years[this.year.value] || [];
    this.button.disabled = this.matches.length === 0;
    this.button.textContent = this.matches.length === 1 ? 'Bekijk passende console' : `Bekijk ${this.matches.length} passende consoles`;
    this.results.hidden = true;
  }

  showResults() {
    if (!this.matches?.length) return;
    if (this.matches.length === 1) {
      window.location.assign(this.matches[0].url);
      return;
    }
    this.results.innerHTML = `<strong>${this.matches.length} passende Kuda consoles voor ${this.escape(this.activeBrand.name)} ${this.escape(this.activeModel.name)} uit ${this.escape(this.year.value)}</strong><div class="bn-kuda-finder__links">${this.matches.map(item => `<a href="${item.url}">${this.escape(item.title)} <span>Artikel ${this.escape(item.sku)}</span></a>`).join('')}</div>`;
    this.results.hidden = false;
  }

  resetResults() {
    this.matches = [];
    this.button.disabled = true;
    this.button.textContent = 'Bekijk passende consoles';
    this.results.hidden = true;
  }

  slug(value) {
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  escape(value) {
    const node = document.createElement('span');
    node.textContent = String(value);
    return node.innerHTML;
  }
}

if (!customElements.get('kuda-finder')) customElements.define('kuda-finder', KudaFinder);
